<template>
  <v-application v-if="access.employee_list">
    <v-layout row class="ma-2">
      <v-flex md9>
        <v-crud-card
          name="employee"
          v-bind:num-pages="num_pages"
          v-model="page"
          v-bind:headers="headers"
          to="/employees/list"
          v-bind:data="data"
          v-bind:remove="remove"
          @change-pagination="changePagination"
          :loading_items_table_data="employee_loading"
          Employees
          v-bind:add_button_name="'add_employee'"
        >
          <template #top>
            <v-combobox
              clearable
              v-model="store"
              :label="$t('stores')"
              hide-details
              v-bind:items="stores"
              item-value="_id"
              item-text="name"
              :menu-props="{ minWidth: '230px', maxWidth: '230px' }"
            />
          </template>
          <v-spacer />
          <template #search>
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                :autofocus="search_field"
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), update();
                  }
                "
                @change="update()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <v-card-actions>
              <template>
                <v-spacer></v-spacer>
                <v-btn icon @click="downloadEmployees" :disabled="disabledDownloadEmployeesButton">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
            </v-card-actions>
          </template>
          <v-card-text>
            <v-text-field
              :label="$t('name')"
              v-model="employee.name"
              color="#54BD5F"
            />
            <v-text-field
              :label="$t('email')"
              v-model="employee.email"
              color="#54BD5F"
              prepend-icon="mdi-email"
            />
            <v-text-field
              prefix="+998"
              v-mask="mask"
              :label="$t('phone_number')"
              v-model="employee.phone_number"
              color="#54BD5F"
              prepend-icon="mdi-phone"
            />
            <v-combobox
              v-model="employee.role"
              v-bind:items="roles"
              item-value="value"
              item-text="name"
              prepend-icon="mdi-account-multiple"
              :label="$t('role')"
              color="#54BD5F"
            />
            <v-text-field
              v-model="employee.password"
              :label="$t('password')"
              :type="is_password ? 'password' : ''"
              v-mask="pass_mask"
              counter="4"
              prepend-icon="mdi-security"
            >
              <template #append>
                <v-btn
                  v-if="is_password"
                  icon
                  text
                  @click="is_password = !is_password"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn v-else icon text @click="is_password = !is_password">
                  <v-icon>mdi-eye-off</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-card-text>
          <v-list class="px-2">
            <v-list-item
              v-for="(service, index) in employee.services"
              v-bind:key="index"
            >
              <v-list-item-content>
                <v-list-item-title>{{
                  service.service_name
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="service.available" />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import xlsx from "xlsx";
import fileSaver from "file-saver";
import Services from "../mixins/services";
export default {
  name: "Employees",
  mixins: [Services],
  data: () => ({
    mask: "(##) ###-##-##",
    pass_mask: "####",
    is_password: true,
    employee_edit_index: -1,
    disabledDownloadEmployeesButton: false,
    page: 1,
    num_pages: 0,
    roles: [],
    employee: {
      services: [],
    },
    headers: [
      { text: "Name", value: "name", available: true },
      { text: "Email", value: "email", available: true },
      { text: "Phone", value: "phone_number", available: true },
      { text: "Role", value: "role", align: "right", available: true },
    ],
    data: [],
    employee_loading: false,
    search: "",
    search_field: false,
    search_text: false,
  }),
  methods: {
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    async changePagination(page) {
      this.page = page;
      const query = {
        ...this.$route.query,
        page: this.page,
      };
      await this.$router.push({ path: this.$route.path, query: query });
      this.update(this.params);
    },
    async save() {
      var employee = this.$copy(this.employee);
      employee.role = employee.role["name"];

      if (this.employee_edit_index == -1) {
        this.$communicator.then(
          this,
          await this.$communicator("create_employee", {
            params: employee,
          }),
        );
        this.update();
      } else {
        this.$communicator.then(
          this,
          await this.$communicator("update_employee", {
            arguments: [this.employee_edit_index],
            params: employee,
          }),
        );
        this.update();
      }
    },
    async remove(items) {
      const indeces = [];
      for (const index in items) {
        indeces.push(items[index]._id);
      }
      await this.$communicator("delete_employees", {
        params: {
          indexes: indeces,
        },
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.update();
    },
    edit(item) {
      if (item === null) {
        this.employee = {
          services: [],
        };
        for (const index in this.services) {
          this.employee.services.push({
            service: this.services[index]._id,
            availabe: false,
            service_name: this.services[index].name,
          });
        }
        this.employee_edit_index = -1;
      } else {
        this.employee = item;
        this.employee_edit_index = this.employee["_id"];
        this.employee.phone_number = this.$communicator.make_phone_number(
          this.employee.phone_number,
        );
        delete this.employee["_id"];
      }
    },
    async update() {
      this.employee_loading = true;
      const employees = this.$communicator.then(
        this,
        await this.$communicator("employees", {
          arguments: [10, this.page],
          params: {
            search: this.search,
            service: this.store._id,
          },
        }),
      );
      if (employees) {
        this.num_pages = employees.page;
        this.data = employees.data.map(employee => ({
          ...employee,
          status: employee.is_active ? this.$t("active"): this.$t("inactive")
        }));
      }
      this.employee_loading = false;
    },
    async downloadEmployees() {
      this.disabledDownloadEmployeesButton = true;

      const employees = this.$communicator.then(
        this,
        await this.$communicator("employees", {
          arguments: ["all", this.page],
          params: {
            search: this.search,
            service: this.store._id,
          },
        }),
      );
      this.disabledDownloadEmployeesButton = false;
      if (employees) {
        this.num_pages = employees.page;
        this.data = employees.data;
      }

      const result = employees?.data.map((employee) => 
        ({
          "Name": employee.name,
          Email: employee.email,
          "Phone number": employee.phone_number,
          Status: employee.is_active ? "Active" : "In active",
          Role: employee.role,
          [this.$t('tin')]: employee.tin,
        })
      );

      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "Employees.xlsx");
    }
  },
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", available: true },
      { text: this.$t("email"), value: "email", available: true },
      { text: this.$t("phone_number"), value: "phone_number", available: true },
      { text: this.$t("role"), value: "role", align: "right", available: true },
      { text: this.$t("status"), value: "status", align: "right", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    const query = this.$route.query;
    if (query && query.page) {
      if (this.page != parseInt(query.page)) {
        this.page = parseInt(query.page);
        this.$router.push({ path: this.$route.path, query: this.page });
        this.update();
      }
    }
  },
  watch: {
    store: {
      deep: true,
      handler() {
        if (!this.store) {
          this.store = { _id: "", name: this.$t("all_stores") };
        }

        this.$store.commit("setItemsService", this.store);
        this.update();
      },
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
  },
};
</script>
